import React from 'react';
import { Typography } from 'antd';
import { ImportMember } from 'works/graphql/validate-works-membership-import';
import { MembersAddMultipleReviewTable } from './members-add-multiple-review-table';
import { MembersAddMultipleReviewErrors } from './members-add-multiple-review-errors';
import { ContentContainer, Icon } from '@common/components';
import { CSVError } from 'works/legacy/lib/csv_error';

const { Text } = Typography;

type Props = {
  importMembers: ImportMember[];
  errors: CSVError[];
};

export function MembersAddMultipleReview({ importMembers, errors }: Props) {
  const usersCounter = importMembers.length;

  const relativeText = usersCounter > 1 ? 'users are' : 'user is';

  return (
    <>
      {!errors.length ? (
        <ContentContainer
          title="Review Members List to Import"
          header={
            <Text>
              <span className="text-heavy">{usersCounter}</span> {relativeText}{' '}
              ready to be created
            </Text>
          }
        >
          <MembersAddMultipleReviewTable importMembers={importMembers} />
        </ContentContainer>
      ) : (
        <ContentContainer
          title={
            <>
              <Icon icon="ban" kind="regular" color="coral" size="xl" />
              The upload file can&apos;t be loaded
            </>
          }
          header={
            <Text>
              Correct the errors below and upload a valid file when ready.
            </Text>
          }
        >
          <MembersAddMultipleReviewErrors errors={errors} />
        </ContentContainer>
      )}
    </>
  );
}
